module.exports = __webpack_public_path__ + "static/img/lucky_draw_kv@2x.40a7d3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/greenchannel/lucky_draw_kv@2x.png
// module id = S8ig
// module chunks = 1